// extracted by mini-css-extract-plugin
export const root = "partner-list-module--root--3SCEL";
export const item = "partner-list-module--item--2rwC2";
export const image = "partner-list-module--image--2B4iU";
export const imageWrap = "partner-list-module--imageWrap--3bDFz";
export const text = "partner-list-module--text--3M9Xu";